export const RICH_CONTRACT_DATA_REGISTRY =
  'QmeacC3QZgWaYYrd6m4b7dbBQVEZcgei5XFhxrq5czn5u3';
export const SITE_ID = 'NYKJUYYQ';
export const moderators = [
  '0x0b17cf48420400e1D71F8231d4a8e43B3566BB5B',
  '0x91aef3c3b9bab2c306548269ff9b6771f2b107d8',
  '0x95a223299319022a842d0dfe4851c145a2f615b9',
  '0x29e1a61fccd40408f489336993e798d14d57d77f',
  '0x08eec580ad41e9994599bad7d2a74a9874a2852c',
  '0x1861974f32eaCDCceD0F81b0f8eCcFeD58153a9D',
];
export const supportedLanguages = ['en', 'es', 'ja'];

